/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagenext2Inputs */

const en_ticketpagenext2 = /** @type {(inputs: Ticketpagenext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const de_ticketpagenext2 = /** @type {(inputs: Ticketpagenext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Ticketpagenext2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagenext2 = /** @type {((inputs?: Ticketpagenext2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagenext2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagenext2(inputs)
	return de_ticketpagenext2(inputs)
});
export { ticketpagenext2 as "ticketPageNext" }